"use client";
import { useEffect, useState, useId } from "react";
import PropTypes from "prop-types";
import { Tab } from "@headlessui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useSelector, useDispatch } from "react-redux";
import {
  handleDetailInfoModalOpened,
  setStickyHeaderMenuItems,
  setSelectedNearbyPoiInfo,
} from "@/src/store/listingDetail";

import { getNearbyPOIs } from "services/listingService";

import { poiTypes } from "./poi-types";

import Title from "components/listing-detail/title";
import NearByListingsCard from "components/cards/nearby-listings-card";
import SwiperWrapper from "components/swiper-wrapper";
import NearbyLocation from "components/listing-detail/nearby-location";

import styles from "./styles.module.css";

const LocationInfoWrap = ({ data }) => {
  const keyId = useId();
  const dispatch = useDispatch();
  const reduxStickyMenuItems = useSelector((state) => state.listingDetail.stickyHeaderMenuItems);

  const {
    location: { city, summary, coordinate },
    id,
  } = data;

  const [datas, setDatas] = useState(null);

  const activePoiCategories = [11, 2, 7, 5, 8];
  const poiTypeIds = poiTypes.map((poiType) => poiType.id);
  const visiblePoiTypes = [];
  activePoiCategories.map((activePoiCategory) => {
    const index = poiTypeIds.indexOf(activePoiCategory);
    return visiblePoiTypes.push(poiTypes[index]);
  });

  const anyPoiesFilled = datas?.some((data) => data?.poies?.length > 0);

  const getData = async () => {
    const response = await getNearbyPOIs({ id, limit: 3, categories: activePoiCategories });
    setDatas(response?.result);
  };

  const handleShowPoiToMapPage = ({ item, categoryId }) => {
    dispatch(handleDetailInfoModalOpened("map"));
    dispatch(setSelectedNearbyPoiInfo({ item, categoryId }));
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (datas && !anyPoiesFilled) {
      const menuItemsFiltered = reduxStickyMenuItems?.filter(
        (stickyMenuItem) => stickyMenuItem.key !== "konum-bilgisi"
      );
      dispatch(setStickyHeaderMenuItems(menuItemsFiltered));
    }
  }, [datas]);

  return (
    <>
      {anyPoiesFilled && (
        <div className={styles.wrapper} id="konum-bilgisi" data-scroll-selector>
          <Title>Konum Bilgisi</Title>
          <div className={styles.inner}>
            <Tab.Group>
              <Tab.List className={styles.tabTitles}>
                <Tab>Yakınında Neler Var?</Tab>
              </Tab.List>
              <Tab.Panels className={styles.tabContents}>
                <Tab.Panel>
                  {datas?.length > 0 && <NearbyLocation location={coordinate} poiList={datas} />}
                  <div className={styles.topWrap}>
                    {city?.name && summary && <span className={styles.location}>{`${city.name} - ${summary}`}</span>}
                    {datas && datas.filter((x) => x.poies.length > 0).length > 1 && (
                      <span className={styles.textLink} onClick={() => dispatch(handleDetailInfoModalOpened("map"))}>
                        Tüm Kategoriler
                      </span>
                    )}
                  </div>
                  {anyPoiesFilled && (
                    <SwiperWrapper>
                      <Swiper
                        navigation={true}
                        loop={false}
                        modules={[Navigation]}
                        slidesPerView={3}
                        className={styles.swiperWrapper}
                      >
                        <div className={styles.listWrap}>
                          {datas.map((item, index) => (
                            <SwiperSlide key={`${keyId}-${index}`}>
                              <NearByListingsCard data={item} onClick={handleShowPoiToMapPage} />
                            </SwiperSlide>
                          ))}
                        </div>
                      </Swiper>
                    </SwiperWrapper>
                  )}
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
      )}
    </>
  );
};

LocationInfoWrap.propTypes = {
  data: PropTypes.object,
};

export default LocationInfoWrap;
